module.exports = __webpack_public_path__ + "static/media/ideal-logo.03dbc60e.png";